import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

var PluginMixins = /*#__PURE__*/_createClass( // 转换成实际属性，__self 为平辅到子节点
function PluginMixins(value, key) {
  _classCallCheck(this, PluginMixins);

  this.value = void 0;
  this.key = void 0;
  this.root = void 0;
  this.index = void 0;
  this.style = {};
  this.start = {};
  this.startAt = {};
  this.target = void 0;
  this.value = value;
  this.key = key;
});

PluginMixins.className = void 0;
PluginMixins.key = void 0;
export { PluginMixins as default };